
import Vue from 'vue';
import Dropdown from '@/components/common/Dropdown/Dropdown.vue';
import DropdownToggler from '@/components/common/Dropdown/DropdownToggler.vue';
import DropdownMenu from '@/components/common/Dropdown/DropdownMenu.vue';
import DropdownItem from '@/components/common/Dropdown/DropdownItem.vue';
import type { SelectableOption } from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import ChevronDownIcon from '~/assets/svg/chevron-down.vue.svg';
import CheckIcon from '~/components/partials/jobs/JobsDropdown/images/check-icon.vue.svg';

export default Vue.extend({
  name: 'BravadoSelectV3',
  components: {
    Dropdown,
    DropdownToggler,
    DropdownMenu,
    DropdownItem,
    BravadoText,
    ChevronDownIcon,
    CheckIcon,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Array],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    keyProp: {
      type: String,
      default: 'value',
    },
    dropdownPosition: {
      type: String,
      default: 'left',
      validator(val: string) {
        return ['left', 'right'].includes(val);
      },
    },
    dropdownDirection: {
      type: String,
      default: 'bottom',
      validator(val: string) {
        return ['top', 'bottom'].includes(val);
      },
    },
    multi: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    borderless: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    hint: {
      type: String,
      default: '',
    },
    withIcons: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    labelClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayValue(): string {
      if (this.value === null) return '';

      const values = (this.multi ? this.value : [this.value]) as (string | number)[];
      return (this.options as SelectableOption[])
        .reduce((acct, option) => {
          if (!values.includes(option.value)) return acct;
          let label = option.label;
          if (this.withIcons) {
            label = `${option.icon} ${option.label}`;
          }
          acct.push(label);
          return acct;
        }, [] as string[])
        .join(', ');
    },
    noOptionSelected() {
      const isArrayAndIsEmpty = Array.isArray(this.value) && !this.value.length;
      // @ts-ignore
      return !(this.value || this.displayValue) || isArrayAndIsEmpty;
    },
    rootClass() {
      return {
        'bravado-select-v3': true,
        'bravado-select-v3--disabled': this.disabled,
        'bravado-select-v3--borderless': this.borderless,
        'bravado-select-v3--invalid': !this.isValid,
        'bravado-select-v3--with-icons': this.withIcons,
      };
    },
  },
  methods: {
    handleChange(option: SelectableOption) {
      let value = option.value as string | number | (string | number)[];

      if (this.multi) {
        const currentValues = this.value as (string | number)[];
        value = currentValues.includes(option.value)
          ? currentValues.filter(v => v !== option.value)
          : [...currentValues, option.value];
      }

      this.$emit('input', value);
    },
  },
});
